import React from 'react'
import { ReviewItems } from '../ReviewItems'
import { formatReviewString } from '../../utilities'
import {
  contractNumberLabel,
  grantNumberLabel,
  executiveDirectorLabel
} from '../../strings/labels'
import { awardType } from '../../strings/types'

export const ReviewAward = ({
  award_type,
  award_number,
  executive_director,
  editFieldName,
  onClick
}) => {
  let details = [
    {
      heading:
        award_type == awardType.grant ? grantNumberLabel : contractNumberLabel,
      value: formatReviewString(award_number)
    },
    {
      heading: executiveDirectorLabel,
      value: formatReviewString(executive_director)
    }
  ]

  const addCommonProps = items =>
    items.map(item => {
      return {
        ...item,
        field_name: editFieldName,
        onClick
      }
    })

  details = addCommonProps(details)

  return (
    <React.Fragment>
      <ReviewItems items={details} />
    </React.Fragment>
  )
}
